import React, { useState } from 'react';
import { Space } from 'antd';
import styles from './index.module.scss';

// 定义组件属性接口
interface SwitchDateProps<T extends string> {
  options: { label: string; value: T }[];
  defaultValue?: T;
  onChange?: (value: T) => void;
  className?: string;
}

// 定义组件
const SwitchDate = <T extends string>({ defaultValue, options, onChange, className }: SwitchDateProps<T>) => {
  const [activeKey, setActiveKey] = useState<T | undefined>(defaultValue);

  const handleDateChange = (value: T) => {
    setActiveKey(value);
    onChange?.(value);
  };

  return (
    <Space size={8} className={className}>
      {options.map((item, index) => (
        <div
          key={index}
          className={`${styles.dateBtn} ${activeKey === item.value && styles.active}`}
          onClick={() => handleDateChange(item.value)}
        >
          {item.label}
        </div>
      ))}
    </Space>
  );
};

export default SwitchDate;
